import { mapValues } from '../../../utils/map-values';
import { getTypeOfValue, ValueType } from './get-type-of-value';
import { SerializedValueType } from './serialized-value';
const serializeObject = (object) => {
    return mapValues(object, serializeValue);
};
const serializeArray = (array) => {
    return array.map(element => serializeValue(element));
};
const serializeDate = (date) => {
    return {
        _type_: SerializedValueType.Date,
        _value_: date.toISOString()
    };
};
const serializeSet = (set) => {
    return {
        _type_: SerializedValueType.Set,
        _value_: serializeArray(Array.from(set))
    };
};
const serializeMap = (map) => {
    return {
        _type_: SerializedValueType.Map,
        _value_: serializeArray(Array.from(map))
    };
};
export const serializeValue = (value) => {
    const type = getTypeOfValue(value);
    switch (type) {
        case ValueType.Object:
            return serializeObject(value);
        case ValueType.Array:
            return serializeArray(value);
        case ValueType.Date:
            return serializeDate(value);
        case ValueType.Set:
            return serializeSet(value);
        case ValueType.Map:
            return serializeMap(value);
        case ValueType.Unsupported:
            throw new Error(`Unsupported value '${value}' could not be serialized`);
        default:
            return value;
    }
};
//# sourceMappingURL=serialize-value.js.map